import VGCatalog from "../catalog/catalog";
import {findID} from "../../../../../../../modules/vegas/js/util";
import VGCatalogCart from "../cart/cart";

class VGCatalogOrder extends VGCatalog {
	constructor() {
		super();
	}

	make($form, callback) {
		let route = $form.getAttribute('action'),
			params = new FormData($form);

		axios.post(route, params).then((response) => {
			if (typeof callback === "function") {
				return callback(response.data);
			}
		});
	}

	courier() {
		return new VGCatalogOrderCourier();
	}

	update() {
		new VGCatalogCart().update();
	}
}

class VGCatalogOrderCourier {
	constructor() {}

	init() {
		const _this = this;
		let $mapAddress = findID('map-courier-address')

		if (typeof ymaps !== 'undefined' && $mapAddress) {
			ymaps.ready(function () {
				let suggestView = new ymaps.SuggestView("user_address_courier", {
					provider: {
						suggest: (function (request) {
							return ymaps.suggest("Калуга, " + request)
						})
					}
				});

				suggestView.events.add('select', function (e) {
					let addr = e.get('item').value.trim();

					new VGCatalogCart().update();
				});
			});
		}
	}
}

export default VGCatalogOrder;
